import { fmtCurrency } from "../../../../utils/functions";
import Row from "./Row";
import sharedStyles from "./checkout.module.css";
import styles from "./result.module.css";

export default function SuccessStep({
  product,
  productType,
  currency,
  verifiedData,
  onDashboard,
}) {
  const isPack = productType === "pack";
  const { name, price } = product;
  const isNew = verifiedData?.isNewAccount;

  return (
    <div className={styles.center}>
      <div className={`${styles.iconCircle} ${styles.iconSuccess}`}>✓</div>

      <h2 className={styles.titleLg}>Payment confirmed!</h2>
      <p className={styles.descWide}>
        {isPack
          ? `Your ${product.credits} Hiring Credits are ready to use.`
          : `Your ${name} Annual Plan is now active.`}
        <br />
        {isNew ? (
          <>
            We've created your account and emailed your login details to{" "}
            <strong className={styles.strong}>
              {verifiedData?.user?.email}
            </strong>
            .
          </>
        ) : (
          <>
            A receipt has been sent to{" "}
            <strong className={styles.strong}>
              {verifiedData?.user?.email}
            </strong>
            .
          </>
        )}
      </p>

      {isNew && (
        <div className={styles.loginBox}>
          <div className={styles.loginTitle}>🔑 Your new account</div>
          <div className={styles.loginRows}>
            <Row label="Login email" value={verifiedData?.user?.email || "—"} />
            <Row
              label="Temporary password"
              value={verifiedData?.tempPassword || "sent by email"}
              color="#C8D4E8"
            />
          </div>
          <div className={styles.loginNote}>
            Use these to sign in, or click the login link in your email. You'll
            be asked to set your own password on first sign-in.
          </div>
        </div>
      )}

      <div className={styles.recapBox}>
        <div className={styles.recapRows}>
          <Row
            label="Product"
            value={isPack ? `${name} Pack` : `${name} Annual Plan`}
          />
          <Row label="Paid" value={fmtCurrency(price, currency)} highlight />
          {isPack && (
            <Row
              label="Credits added"
              value={`${product.credits}C`}
              color="#22C55E"
            />
          )}
          {!isPack && (
            <>
              <Row
                label="Credits / month"
                value={`${product.creditsPerMonth}C`}
                color="#22C55E"
              />
              <Row
                label="Valid until"
                value={
                  verifiedData?.expiresAt
                    ? new Date(verifiedData.expiresAt).toLocaleDateString(
                        "en-GB",
                        {
                          day: "numeric",
                          month: "long",
                          year: "numeric",
                        },
                      )
                    : "12 months from today"
                }
              />
            </>
          )}
          {verifiedData?.reference && (
            <Row label="Reference" value={verifiedData.reference} />
          )}
        </div>
      </div>

      <button
        onClick={onDashboard}
        className={sharedStyles.btnSuccess}
        style={{ marginBottom: 12 }}
      >
        {isNew ? "Set up your account →" : "Go to dashboard →"}
      </button>

      <p className={styles.footNote}>
        Check your email for your login link and receipt.
      </p>
    </div>
  );
}
